import type {AppThunk} from '../../../actions/types'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {ROOT_PROJECT_ID} from '../../../types'
import {preloadProjectPage} from '../ProjectPage/ProjectPage.preload'

export const preloadFavoriteProjectsPage =
  (onlyFavorites: boolean): AppThunk<LoadedEndpoints> =>
  dispatch => [
    ...dispatch(
      preloadProjectPage({isFavoriteProjectsPage: true, onlyFavorites, projectId: ROOT_PROJECT_ID}),
    ),
  ]
